import type { IconName } from "@similarweb/icons";

import { BounceRate, DefaultCellRightAlign } from "app/components/React/Table/cells";
import type { MetricKeyNames } from "app/constants/MmxChannels";
import {
    abbrNumberFilter,
    numberFilter,
    minVisitsAbbrFilter,
    percentageSignFilter,
    timeFilter,
} from "app/filters/ngFilters";
import { pagesPerVisitsFormatter } from "pro-features/pages/segments/components/benchmarkOvertime/utils";

type IEngagementMetricVerticals = Record<MetricKeyNames, IEngagementMetricVertical>;

interface IEngagementMetricVertical {
    title: string;
    dataKey: MetricKeyNames;
    name: string;
    filter: any;
    icon: IconName;
    yAxisFilter?: any;
    percentFilter?: any;
    format?: string;
    cellComponent?: any;
    invertChange?: boolean;
}

export const EngagementVerticals: IEngagementMetricVerticals = {
    Visits: {
        title: "segments.mmx.graph.tab.visits",
        dataKey: "Visits",
        name: "Visits",
        filter: [minVisitsAbbrFilter],
        percentFilter: [percentageSignFilter],
        yAxisFilter: [abbrNumberFilter, true],
        icon: "visits",
        cellComponent: DefaultCellRightAlign,
        format: "minVisitsAbbr",
    },
    PageViews: {
        title: "segments.mmx.graph.tab.pageviews",
        dataKey: "PageViews",
        name: "PagesViews",
        filter: [minVisitsAbbrFilter],
        yAxisFilter: [abbrNumberFilter, true],
        icon: "impressions",
        cellComponent: DefaultCellRightAlign,
        format: "minVisitsAbbr",
    },
    PagesPerVisit: {
        title: "segments.mmx.graph.tab.pages.per.visit",
        dataKey: "PagesPerVisit",
        name: "PagesPerVisit",
        filter: [pagesPerVisitsFormatter],
        yAxisFilter: [numberFilter, 2],
        icon: "pages-per-visit",
        cellComponent: DefaultCellRightAlign,
        format: "number",
    },
    Duration: {
        title: "segments.mmx.graph.tab.visit.duration",
        dataKey: "Duration",
        name: "VisitDuration",
        filter: [timeFilter],
        icon: "avg-visit-duration",
        cellComponent: DefaultCellRightAlign,
        format: "time",
    },
    BounceRate: {
        title: "segments.mmx.graph.tab.bounce.rate",
        dataKey: "BounceRate",
        name: "BounceRate",
        filter: [percentageSignFilter],
        icon: "bounce-rate-2",
        format: "percentagesign",
        cellComponent: BounceRate,
        invertChange: true,
    },
};
